<!--
  CareManagement_QA.vue — Care Management > QA: the title and the two pages' tabs.

  Each tab is its own page with its own URL, data, filters and saved filters:
    Report       QaReport.vue       call-quality scorecards (care managers, their graded calls, one call)
    Audit calls  QaAuditCalls.vue   the calls a manager can audit by hand

  Presentation follows CareManagement_DischargeWaterfall: cm-toolbar header,
  cm-panel surfaces on #F8F8F9, dense inline-styled tables, tabular numerals,
  #0284C7 for anything selectable.
-->
<template>
  <div class="qa-page" style="display: flex; flex-direction: column; height: 100%; min-height: 0; background: #F8F8F9;">
    <div class="cm-toolbar">
      <h2>Call Quality</h2>
      <span style="color: #A5A5A6;">AI-assisted and human-submitted audits at the individual call level</span>
      <div v-if="canAudit" class="cm-seg" style="margin-left: 12px;">
        <router-link v-slot="{ navigate }" :to="reportLocation" custom>
          <button :class="{ on: !showAuditCalls }" data-test="qa-tab-report" @click="navigate">Report</button>
        </router-link>
        <router-link v-slot="{ navigate }" :to="auditLocation" custom>
          <button :class="{ on: showAuditCalls }" data-test="qa-tab-audit" @click="navigate">Audit calls</button>
        </router-link>
      </div>
    </div>

    <QaAuditCalls v-if="showAuditCalls" :session-id="initialSessionId" />
    <QaReport v-else :can-audit="canAudit" :cm-user-id="initialCmUserId" :work-id="initialWorkId" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { qaAuditLocation, qaReportLocation } from '../../../router/caremanagement_routes';
import QaAuditCalls from './QaAuditCalls.vue';
import QaReport from './QaReport.vue';

export default {
  name: 'CareManagementQA',
  components: { QaAuditCalls, QaReport },
  props: {
    initialMode: { type: String, default: 'report' },
    initialCmUserId: { type: Number, default: null },
    initialWorkId: { type: Number, default: null },
    initialSessionId: { type: String, default: null },
  },
  data() {
    return { reportLocation: qaReportLocation(), auditLocation: qaAuditLocation() };
  },
  computed: {
    ...mapGetters('auth', ['current_user']),
    ...mapGetters('tenant', ['isManagerViewer', 'isTenantAdmin']),
    canAudit() { return this.isManagerViewer || this.isTenantAdmin || !!this.current_user?.is_superuser; },
    showAuditCalls() { return this.initialMode === 'audit' && this.canAudit; },
  },
};
</script>

<style scoped src="./qa.css"></style>
